var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"}));
}

Filter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-filter"};

module.exports = Filter;

Filter.default = Filter;
